module.exports = __webpack_public_path__ + "officialStatic/img/case40.61b9e47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case40.jpg
// module id = y44U
// module chunks = 0